import React from "react";
import image1 from "assets/img/profile/sakinah-branch.png";
import { Link } from "react-router-dom";
import { FaStore } from "react-icons/fa";

interface BranchCardProps {
  id: number;
  slug: string;
  name: string;
  open_time: string;
  address: string;
  admin?: string[];
}

const BranchCard: React.FC<BranchCardProps> = (props) => {
  const { id, slug, name, open_time, address, admin } = props;

  return (
    <Link to={`/admin/branches/${slug}`}>
      <div className="flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 transition-all duration-300 hover:scale-105 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <div className="flex h-[83px] w-[83px] items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
              <FaStore className="h-5 w-5 text-brand-500" />
            </div>
          </div>
          <div className="ml-4">
            <p className="text-base font-bold text-navy-700 dark:text-white">
              {name}
            </p>
            <p className="mt-2 text-sm text-gray-600">
              OPEN
              <span className="ml-1 font-medium tracking-wide text-brand-500 hover:text-brand-500 dark:text-white">
                {open_time}
              </span>
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BranchCard;
